module.exports = __webpack_public_path__ + "img/Briefcase.dc8a3282.svg";